import React from 'react'
import './ErrorsTable.scss'

const ErrorsTable = ({
  data,
}: {
  data: { row: number; receiver?: string; amount?: string | number }[]
}) => {
  const hasReceiver = data?.some((tx) => tx?.receiver)
  const hasAmount = data?.some((tx) => tx?.amount)

  return (
    <table className="errorsTable">
      <thead>
        <tr>
          <th className="headerCell">Row</th>
          {hasReceiver ? <th className="headerCell">Receiver</th> : null}
          {hasAmount ? <th className="headerCell">Amount</th> : null}
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => (
          <tr key={index}>
            <td className="bodyCell">{item.row}</td>
            <td className="bodyCell">{item?.receiver || '-'}</td>
            <td className="bodyCell">{item?.amount || '-'}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default ErrorsTable
